import type { IModularBenefitMessages } from '@ben/shared/types/columbia';
import { memo } from 'react';
import { FormProvider } from 'react-hook-form';
import EnrolmentSettings from '../enrolment-settings/enrolment-settings';
import { SectionContainer } from './styles';
import type { EnrolmentSettingsForm } from './types';

interface EnrollmentSettingsElementProps {
  form: EnrolmentSettingsForm;
  warnings: IModularBenefitMessages;
  successes: IModularBenefitMessages;
}

const EnrollmentSettingsElement = ({
  form,
  warnings,
  successes,
}: EnrollmentSettingsElementProps) => (
  <SectionContainer>
    <FormProvider {...form}>
      <EnrolmentSettings warnings={warnings} successes={successes} />
    </FormProvider>
  </SectionContainer>
);

export default memo(EnrollmentSettingsElement);
